<section>
    <h2 class="page-title">{{ pageData.pageTitle }}</h2>
    <div class="content-block">
        <h3 class="content-header">{{ pageData.header }}</h3>
        <xm-media-image aria-hidden="true" class="icon" [imageOptions]="icon" size="height"></xm-media-image>
        <div class="description">{{ pageData.description }}</div>
        <div *ngIf="pageData.actionHeading" class="action-head">{{ pageData.actionHeading }}</div>
        <div *ngIf="pageData.actionDescription && !isMobile" class="action-head">{{ pageData.actionDescription }}</div>
        <a *ngIf="(pageData.actionDescription && pageData.actionLink) && isMobile" [href]="pageData.actionLink" class="action-head is-mobile">{{ pageData.actionDescription }}</a>
    </div>
    <div class="action">
        <cms-text class="left-btn" *ngIf="pageData.secondaryCta" [originalText]="pageData.secondaryCta"></cms-text>
        <cms-text *ngIf="pageData.primaryCta" [originalText]="pageData.primaryCta"></cms-text>
    </div>
</section>
